// https://www.figma.com/file/mrdiByIw3khIMAh05RjAcL/002---PLX-UI-Library?node-id=35285%3A37466&mode=dev
import { Flex, FlexProps } from '@chakra-ui/react';
import { px, py } from 'common/layouts/layout.styles';
import { useRouter } from 'next/router';
import { ReactNode } from 'react';

interface OneColumnProps {
  children: ReactNode;
  pb?: FlexProps['pb'];
  gap?: FlexProps['gap'];
}

const OneColumn = ({ children, gap, pb }: OneColumnProps) => {
  const { pathname } = useRouter();

  return (
    <Flex
      role="mainContent"
      id="mainContent"
      align="stretch"
      gap={gap ?? 10}
      direction="column"
      py={py}
      px={px}
      pb={pb}
      minWidth={0}
      overflow="auto"
      width="100%"
      bg={
        pathname === '/contract' ||
        pathname === '/payments' ||
        pathname === '/remittance-sheet' ||
        pathname.endsWith('/new') ||
        pathname.endsWith('/[id]')
          ? 'semantic.surface.1'
          : 'transparent'
      }
    >
      {children}
    </Flex>
  );
};

export default OneColumn;
